import { put } from 'redux-saga/effects';
import http from "axios";

import {
    GET_ACCOUNTING_REQUESTS,
    ACCOUNTING_REQUEST_CONFIRM,
    ACCOUNTING_REQUEST_CANCEL,
    ACCOUNTING_ALL_COST_CONFIRM
} from '../../../api/constants'

import {
    SWAL_ERROR_TITLE,
    SWAL_TYPE_ERROR,
    SWAL_TYPE_SUCCESS,
    SWAL_SUCCESS_TITLE,
    SWAL_TYPE_INFO,
    COST_CONFIRMING_MESSAGE,
    OPERATION_PROCESSING
} from '../../../utils/constants'

import {
    getAccountingRequestsSuccessful,
    getAccountingRequestsFailure,
    accountingRequestConfirmSuccessful,
    accountingRequestConfirmFailure,
    accountingRequestCancelSuccessful,
    accountingRequestCancelFailure,
    confirmAllCostSuccessful,
    confirmAllCostFailure
} from '../../actions'

import { swalOpen } from '../../utils';
import {setLoading} from "../../actions/loading";

export function* getAccountingRequests({ payload }) {
    try {
        const { accessToken, employee, month, year } = payload
        let body = new URLSearchParams();
        body.append("accessToken", accessToken);
        body.append("employee", employee);
        body.append("month", month);
        body.append("year", year);
        yield put(setLoading(true))
        const response = yield http.post(GET_ACCOUNTING_REQUESTS, body);
        if (!response.data.err) {
            yield put(getAccountingRequestsSuccessful(response.data.data));
            yield put(setLoading(false))
        } else {
            yield put(getAccountingRequestsFailure(response.data.err));
            yield put(setLoading(false))
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch getAccountingRequest.Error : ", error)
    }
}


export function* accountingRequestConfirm({ payload }) {
    try {
        const { costData, accessToken } = payload
        let body = new URLSearchParams();
        body.append("accessToken", accessToken);
        body.append("costId", costData.costId);
        const response = yield http.post(ACCOUNTING_REQUEST_CONFIRM, body);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            yield put(accountingRequestConfirmSuccessful(costData.costId));
        } else {
            yield put(accountingRequestConfirmFailure());
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch accountingRequestConfirm.Error : ", error)
    }
}

export function* accountingRequestCancel({ payload }) {
    try {
        const { costData, accessToken, description } = payload
        let body = new URLSearchParams();
        body.append("description", description);
        body.append("accessToken", accessToken);
        body.append("costId", costData.costId);

        const response = yield http.post(ACCOUNTING_REQUEST_CANCEL, body);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            yield put(accountingRequestCancelSuccessful(costData.costId));
        } else {
            yield put(accountingRequestCancelFailure());
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch accountingRequestCancel.Error : ", error)
    }
}


export function* confirmAllCost({ payload }) {
    try {
        swalOpen(OPERATION_PROCESSING, COST_CONFIRMING_MESSAGE, SWAL_TYPE_INFO, false);
        const { accessToken, employee, month, year } = payload
        let body = new URLSearchParams();
        body.append("accessToken", accessToken);
        body.append("employee", employee);
        body.append("month", month);
        body.append("year", year);
        const response = yield http.post(ACCOUNTING_ALL_COST_CONFIRM, body);
        if (!response.data.err) {
            swalOpen(SWAL_SUCCESS_TITLE, response.data.data, SWAL_TYPE_SUCCESS, false);
            yield put(confirmAllCostSuccessful());
            yield setTimeout(function () {
                window.location.reload()
              }, 1000);
        } else {
            yield put(confirmAllCostFailure());
            swalOpen(SWAL_ERROR_TITLE, response.data.data, SWAL_TYPE_ERROR, false);
        }
    } catch (error) {
        console.error("Error happened when try to fetch confirmAllCost.Error : ", error)
    }
}


